import { observable } from 'mobx';

export interface OnlineApplicationApprovalLogArgs {
  id: number;
  online_application_id: number;
  logged_by_admin_id: number;
  action_status: string;
  comment?: string;
  created_at: string;
  updated_at: string;
  logged_by_admin?: {
    id: number;
    name?: string;
    email?: string;
  };
}

export class OnlineApplicationApprovalLog {
  @observable id: number;
  @observable onlineApplicationId: number;
  @observable loggedByAdminId: number;
  @observable actionStatus: string;
  @observable comment?: string;
  @observable createdAt: string;
  @observable updatedAt: string;
  @observable loggedByAdmin?: {
    id: number;
    name?: string;
    email?: string;
  };

  constructor(args: Partial<OnlineApplicationApprovalLogArgs> = {}) {
    this.id = args.id || 0;
    this.onlineApplicationId = args.online_application_id || 0;
    this.loggedByAdminId = args.logged_by_admin_id || 0;
    this.actionStatus = args.action_status || '';
    this.comment = args.comment;
    this.createdAt = args.created_at || '';
    this.updatedAt = args.updated_at || '';
    this.loggedByAdmin = args.logged_by_admin;
  }

  static getActionStatusLabel(status: string): string {
    switch (status) {
      case 'admin_applied':
        return '申請';
      case 'first_approved':
        return '1次承認';
      case 'final_approved':
        return '最終承認';
      case 'user_apply':
        return '顧客申込';
      case 'send_back':
        return '差し戻し';
      case 'withdraw':
        return '取り下げ';
      case 'send_email':
        return 'メール送信';
      case 'update_workflow_ids':
        return 'ワークフローID更新';
      default:
        return status;
    }
  }
}

export default OnlineApplicationApprovalLog;
